var _excluded = ["className", "children", "component", "href", "onClick", "onKeyDown", "onKeyUp", "selected", "tabKey", "target"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useContext, useEffect, useRef, useState } from "react";
import ATabContext from "./ATabContext";
import { keyCodes } from "../../utils/helpers";
import { useCombinedRefs } from "../../utils/hooks";
import "./ATabs.scss";
var tabCounter = 1;
var ATab = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var propsClassName = _ref.className,
    children = _ref.children,
    component = _ref.component,
    href = _ref.href,
    _onClick = _ref.onClick,
    _onKeyDown = _ref.onKeyDown,
    _onKeyUp = _ref.onKeyUp,
    selected = _ref.selected,
    tabKey = _ref.tabKey,
    target = _ref.target,
    rest = _objectWithoutProperties(_ref, _excluded);
  var tabRef = useRef(null);
  var combinedRef = useCombinedRefs(ref, tabRef);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    tabId = _useState2[0],
    setTabId = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    isSelected = _useState4[0],
    setIsSelected = _useState4[1];
  var _useContext = useContext(ATabContext),
    tabChanged = _useContext.tabChanged,
    setTabChanged = _useContext.setTabChanged,
    scrollToMe = _useContext.scrollToMe,
    vertical = _useContext.vertical;
  useEffect(function () {
    if (tabKey) return;
    if (!tabId) {
      var index = tabCounter++;
      setTabId(index);
      if (selected) {
        setTabChanged(index);
      }
    }
    setIsSelected(tabChanged === tabId);
  }, [setIsSelected, selected, setTabChanged, tabChanged, tabId, tabKey]);
  useEffect(function () {
    if (tabKey) return;
    if (!selected && isSelected) {
      setTabChanged(-1);
      setIsSelected(false);
    }
  }, [selected, tabKey]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (tabKey && selected || isSelected) {
      document.fonts.ready.then(function () {
        scrollToMe(combinedRef);
      });
    }
  }, [selected, isSelected, combinedRef]); // eslint-disable-line react-hooks/exhaustive-deps

  var className = "a-tab-group__tab";
  if (tabKey && selected || isSelected) {
    className += " a-tab-group__tab--selected";
    if (vertical) {
      className += " a-tab-group__tab--selected--vertical";
    }
  }
  if (vertical) {
    className += " a-tab-group__tab--vertical";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var TagName = "div";
  var props = _objectSpread(_objectSpread({}, rest), {}, {
    "aria-selected": Boolean(tabKey && selected || isSelected),
    ref: combinedRef,
    className: className,
    onClick: function onClick(e) {
      !tabKey && setTabChanged(tabId);
      _onClick && _onClick(e);
    },
    onKeyDown: function onKeyDown(e) {
      if (!href && [keyCodes.enter].includes(e.keyCode)) {
        e.preventDefault();
        !tabKey && setTabChanged(tabId);
        _onClick && _onClick(e);
      } else {
        _onKeyDown && _onKeyDown(e);
      }
    },
    onKeyUp: function onKeyUp(e) {
      if ([keyCodes.tab].includes(e.keyCode)) {
        scrollToMe(combinedRef);
      }
      _onKeyUp && _onKeyUp(e);
    },
    role: "tab",
    tabIndex: 0
  });
  if (href) {
    TagName = "a";
    props.href = href;
    props.target = target;
  }
  if (component) {
    TagName = component;
  }
  return /*#__PURE__*/React.createElement(TagName, props, children);
});
ATab.propTypes = {
  /**
   * Sets the base component. Useful for integrating with routers.
   */
  component: PropTypes.elementType,
  /**
   * If specified, the component will render as an HTML link.
   */
  href: PropTypes.string,
  /**
   * Toggles the `selected` state in controlled mode. Provides the default `selected` state in uncontrolled mode.
   */
  selected: PropTypes.bool,
  /**
   * Supplies an identifier to the tab for the purpose of being leveraged by the developer in controlled mode. If absent, uncontrolled mode is assumed.
   */
  tabKey: PropTypes.string,
  /**
   * If the `href` property is defined, the target can be set (ex: `_blank`, `_self`, `_parent`, `_top`)
   */
  target: PropTypes.string
};
ATab.displayName = "ATab";
export default ATab;